import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ProtectedOrganizationRoute } from "@/components/ProtectedOrganizationRoute";

// Club management pages (only existing pages)
const ClubDashboard = lazy(() => import("@/pages/club/ClubDashboard"));

/**
 * Club staff routes
 * Routes for club_staff role
 *
 * Note: Only ClubDashboard exists currently.
 * Add more routes as new pages are created.
 */
export const clubRoutes = (
  <>
    <Route
      path="/club/:orgId"
      element={
        <ProtectedRoute requiredRoles={["club_staff"]}>
          <ProtectedOrganizationRoute>
            <ClubDashboard />
          </ProtectedOrganizationRoute>
        </ProtectedRoute>
      }
    />
  </>
);
